import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { AuthClientConfig } from '@auth0/auth0-angular';
import { ApiService } from 'src/app/api.service';
import { OrganisationService } from 'src/app/organisation.service';
import { Helpers } from 'src/app/app.helpers';
import { RxStompService } from '../../rx-stomp.service';
import { Message } from '@stomp/stompjs';
import { LoadingComponent } from '../../components/loading/loading.component';
import { HeroComponent } from '../../components/hero/hero.component';
import { HomeContentComponent } from '../../components/home-content/home-content.component';
import { RouterLink } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap/tooltip';
import { AsyncPipe, DatePipe } from '@angular/common';

@Component({
  selector: 'app-motortwin-landing',
  templateUrl: './motortwin-landing.component.html',
  styleUrls: ['./motortwin-landing.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LoadingComponent, HeroComponent, HomeContentComponent, RouterLink, NgbTooltipModule, AsyncPipe, DatePipe]
})
export class MotortwinLandingComponent implements OnInit {
  jobs: Array<any>;
  hasApiError = false;
  apiError: string;
  jobTileLimit = 6;
  inContextOrgId: string;
  bannerDismissed = false;
  private readonly bannerStorageKey = 'home.banner.dismissed';

  // @ts-ignore, to suppress warning related to being undefined
  private statusSubscriptions: Array<Subscription>;

  constructor(
    public auth: AuthService,
    private api: ApiService,
    private orgService: OrganisationService,
    private rxStompService: RxStompService,
    private configFactory: AuthClientConfig,
    public helpers: Helpers,
  ) { }

  ngOnInit(): void {

    this.bannerDismissed = this.getBannerDismissedState();

    this.orgService.currentOrg$.subscribe((org) => {
      this.inContextOrgId = (org && org.id) ? org.id : '';
    });

    // If we're authenticated
    this.auth.isAuthenticated$.subscribe((res) => {
      if (res) {
        console.log("******Getting jobs ...");
        this.getJobs();
      }
    });
  }

  dismissBanner() {
    this.bannerDismissed = true;
    this.setBannerDismissedState(true);
  }

  private getBannerDismissedState(): boolean {
    if (typeof window === 'undefined' || !window.localStorage) {
      return false;
    }

    return window.localStorage.getItem(this.bannerStorageKey) === 'true';
  }

  private setBannerDismissedState(isDismissed: boolean) {
    if (typeof window === 'undefined' || !window.localStorage) {
      return;
    }

    window.localStorage.setItem(this.bannerStorageKey, String(isDismissed));
  }

  getJobs() {
    this.unsubscribeFromUpdates();
    this.api.getJobs$(this.inContextOrgId, 10, this.jobTileLimit).subscribe({
      next: (res) => {
        this.hasApiError = false;

        this.jobs = res

        if (!this.statusSubscriptions) {
          this.statusSubscriptions = [];
        }

        for (const job of this.jobs) {

          // Don't watch completed or quaranitined jobs
          if (job.status == 70 || job.status == 80) {
            continue;
          }

          // Subscribe to status updates
          this.statusSubscriptions.push(this.rxStompService
            .watch(`/topic/${job.id}.status`)
            .subscribe((msg: Message) => {
              var destination = msg.headers.destination;
              // Get job id from destination between last / and .status
              var jobId = destination.substring(
                destination.lastIndexOf('/') + 1,
                destination.lastIndexOf('.'));

              // Meh, find out how to properly update the array job
              this.getJobs();
            }));
        }
      },
      error: (error) => {
        this.hasApiError = true;
        this.apiError = error.message;
      },
    });
  }

  getInitiator(job: any) {

    // If we have an org in context, return the person
    if (this.inContextOrgId != '') {
      return " : " + job.initiator;
    }

    // If we don't have an org in context, return the org
    if (this.inContextOrgId == '') {
      return job.org ? " : " + job.org : "";
    }
  }

  ngOnDestroy() {
    this.unsubscribeFromUpdates();
  }

  unsubscribeFromUpdates() {
    if (!this.statusSubscriptions) {
      return;
    }

    console.log("Unsubscribing from status updates ...");
    for (const subscription of this.statusSubscriptions) {
      if (subscription) {
        subscription.unsubscribe();
      }
    }
    this.statusSubscriptions = [];
  }

  getJobTypeClass(jobType: string) {
    if (jobType.startsWith("electro")) {
      return "mag";
    } else if (jobType.startsWith("mech")) {
      return "mech";
    } else if (jobType.startsWith("therm")) {
      return "therm";
    }
    return "";
  }

  getJobStatusClass(status: number) {
    switch (status) {
      case 0:
        return "new";
      case 10:
      case 20:
      case 21:
      case 22:
      case 25:
      case 26:
      case 30:
      case 40:
      case 50:
      case 60:
        return "in_progress";
      case 70:
        return "completed";
      case 80:
        return "quarantined";
      default:
        return "";
    }
  }
}
